import StaticContent from './StaticContent'
import Footer from 'containers/Footer'
import Carousel from './Carousel'
import Header from './Header'
import React from 'react'
import Faq from './Faq'
import './style.scss'

const OnePage: React.FC = () => {
  return (
    <div className='onePage'>
      <Header />
      <Carousel />
      <StaticContent />
      <Faq />
      <Footer />
    </div>
  )
}

export default OnePage